module.exports = __webpack_public_path__ + "img/03.5fb91aba.png";